// Prevent the backspace key from navigating back.
$(document)
  .unbind('keydown')
  .bind('keydown', (event) => {
    var doPrevent = false;
    if (event.keyCode === 8) {
      var d = event.srcElement || event.target,
        tag = d.tagName.toUpperCase(),
        type = (d.type || '').toUpperCase();
      if (
        (tag === 'INPUT' &&
          (type === 'TEXT' ||
            type === 'PASSWORD' ||
            type === 'FILE' ||
            type === 'SEARCH' ||
            type === 'EMAIL' ||
            type === 'NUMBER' ||
            type === 'DATE')) ||
        tag === 'TEXTAREA'
      ) {
        doPrevent = d.readOnly || d.disabled;
      } else {
        doPrevent = true;
      }
    }
    if (doPrevent) {
      event.preventDefault();
    }
  });

// Prevent drag/drop image from navigating page (unless
// it's over an explicit upload drop target we want)
window.addEventListener(
  'dragover',
  function (e) {
    e = e || event;
    e.preventDefault();
  },
  false
);
window.addEventListener(
  'drop',
  function (e) {
    e = e || event;
    e.preventDefault();
  },
  false
);



// WEBPACK FOOTER //
// ./app/browser-hacks.js